import { createFileRoute, redirect } from '@tanstack/react-router';

import { UserRoles } from '~entities/users/model/types';

import { checkMinRoleValue } from '~shared/utils/role-guard';

export const Route = createFileRoute('/_auth/_layout/announcements/new')({
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.ADMIN);
    if (!hasAccess) {
      return redirect({ to: '/dashboard' });
    }
  },
});
